import React from 'react';
import { InputNumber, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import './LaundryCell.scss';

interface LaundryCellProps {
  label: string;
  value?: number;
  placeholder?: string;
  onChange?: (value: number | null) => void;
  disabled?: boolean;
  showTooltip?: boolean;
  tooltipText?: string;
  icon: React.ReactNode;
  isReadonly?: boolean;
  max?: number;
}

const LaundryCell: React.FC<LaundryCellProps> = ({
  label,
  value,
  placeholder,
  onChange,
  disabled = false,
  showTooltip = false,
  tooltipText,
  icon,
  isReadonly = false,
  max,
}) => {

  const handleChange = (newValue: number | null) => {
    onChange?.(newValue);
  };

  return (
    <div className={'laundry-cell-container'}>
      <div className="laundry-cell-description">
        <div className="laundry-cell-header">
          <span className="laundry-cell-label">
            {label}
            {showTooltip && tooltipText && !isReadonly && (
              <Tooltip title={tooltipText} placement="top">
                <InfoCircleOutlined className="info-icon" />
              </Tooltip>
            )}
          </span>
        </div>

        <div className="laundry-cell-icon">{icon}</div>
      </div>

      <div className="laundry-cell-input">
        {isReadonly ? (
          <div className="readonly-value">{value}</div>
        ) : (
          <InputNumber
            type="tel"
            value={value === 0 ? undefined : value}
            onChange={handleChange}
            disabled={disabled}
            min={0}
            maxLength={max}
            placeholder={placeholder}
            className={'laundry-cell-input'}
            controls={false}
            // size="large"
          />
        )}
      </div>
    </div>
  );
};

export default LaundryCell;
